import styled from "styled-components";
import emailjs from 'emailjs-com'
import { Link } from "react-router-dom";



const Funding = () => {

    function sendEmail(e){
        e.preventDefault();

        emailjs.sendForm('service_ec9w4c9', 'template_s5108t6', e.target, 'user_vKLtBLy3sWqstDKzPwIgZ')
            .then((result) => {
                console.log(result);
            }, (error) => {
                console.log(error.text);
        });

        e.target.reset();
    }

    return (
        <Container id ="apply-loan">
            <Content>
                <ContentHeader>
                    <span>Funding Circles</span>
                    <h2>You deserve a better business loan</h2>
                    <p>What makes us better is the simplicity and reliability nature of our services to our customers</p>
                </ContentHeader>
                <div className="funding__caption">
                    <Description>
                        <Caption>
                            <h2>We usually follow 4 steps to get a better business loans</h2>
                        </Caption>
                        <Methods>
                            <MdL>
                                <span>1</span>
                                <div>
                                    <h3>Calculate your loan</h3>
                                    <p>You start by determining ou rloan amount, pay back period and other necessary requirements</p>
                                </div>
                            </MdL>
                            <MdL>
                                <span>2</span>
                                <div>
                                    <h3>Apply in 12 minutes</h3>
                                    <p>You proceed to make an application which takes not more than 12 minutes, filling all details required</p>
                                </div>
                            </MdL>
                            <MdL>
                                <span>3</span>
                                <div>
                                    <h3>Hear from us in 1 hour</h3>
                                    <p>Your request would be responded to within an interval of 1 hour, showing approved or declined</p>
                                </div>
                            </MdL>
                            <MdL>
                                <span>4</span>
                                <div>
                                    <h3>A decision in 24 hours</h3>
                                    <p>If approved, you will be contacted from <b>Winnthako</b> within 24 hours</p>
                                </div>
                            </MdL>
                        </Methods>

                        <ApplyBtn to="/loancalculator">Calculate Your Loan</ApplyBtn>
                    </Description>
                    <form onSubmit={sendEmail}>
                        <Caption className="formCaption">
                            <h3>How much do you need?</h3>
                        </Caption>
                        <div>
                            <label htmlFor="name">Enter your full name</label>
                            <br/>
                            <input type="text" name="name" id="name" placeholder=""/>
                        </div>
                        <div>
                            <label htmlFor="name">Email</label>
                            <br/>
                            <input type="email" name="name" id="name" placeholder=""/>
                        </div>
                        <div>
                            <label htmlFor="contact">Mobile Number</label>
                            <br/>
                            <input type="mobile" name="contact" id="contact" placeholder=""/>
                        </div>
                        <div>
                            <div className="cselect">
                                <label htmlFor="gender">Gender</label>
                                <br/>
                                <select name="gender" id="gender">
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <label htmlFor="occupation">Occupation</label>
                            <br/>
                            <select name="occupation" id="gender">
                                <option value="student">Student</option>
                                <option value="worker">Worker</option>
                                <option value="self employed">Self Employed</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="eligibility">Eligibility Status</label>
                            <br/>
                            <select name="eligibility" id="gender">
                                <option value="collateral">Collateral(100%)</option>
                                <option value="guarantor">Guarantor(70%)</option>
                                <option value="trust">Trust(50%)</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="amount">How much do you need</label>
                            <br/>
                            <input type="number" name="amount" id="contact" placeholder=""/>
                        </div>
                        <div>
                            <label>Why do you need this loan?</label>
                            <br/>
                            <textarea name="message"/>
                        </div>
                        {/* <div>
                            <label>Please upload a clear document of your collateral either in pdf, jpg or png format</label>
                            <br/>
                            <input type="file" id="myFile" name="filename"></input>
                        </div> */}
                        <FormButton>Apply for this loan</FormButton>
                    </form>
                </div>
            </Content>
            
        </Container>
         
    )
}





const ApplyBtn = styled(Link)`
    background: rgb(231, 60, 62);
    padding: 10px 40px;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    color: rgb(255,255,255);
    margin: 20px 0;

    @media(max-width: 500px){
        width: 100%;
        text-align: center;
    }

`


const Container = styled.div`
    padding: 50px 20px;
    @media(min-width: 768px){
        padding: 100px 50px;
    }
    form{
        margin: 20px 0px;
        background: rgb(231, 61, 62);
        color: rgb(255, 255, 255);
        padding: 20px;

        .formCaption{
            text-align: center;
        }
        
        >div{
            margin-bottom: 20px;
        }
       
        select{
            appearance: none;
        }

        input, select, textarea{
            width: 100%;
            padding: 15px 10px;
            font-color: rgb(96, 96, 96);
            font-size: 16px;
            border: none;
            display: inline-block;
        }


        h3{
            color: rgb(255, 255, 255); 
        }

        @media(min-width: 768px){
            width: 45%;
        }
    }

`
const FormButton = styled.button`
        background: rgb(255, 255, 255);
        color: rgb(96, 96, 96) !important;
        padding: 15px 40px;
        border-radius: 5px;
        cursor: pointer;
        display: inline-block;
        color: rgb(255,255,255);
        margin: 20px 0;
        width: 100%;
        text-align: center;
        border: none;
        font-size: 20px;

        :hover{
            
            color: red !important;
            transition: 1s ease;
        }


`
const Content = styled.div`

    @media(min-width: 768px){
        .funding__caption{
            display: flex;
            justify-content: space-between;
        }
    }

`



const ContentHeader = styled.div`
    text-align:center;

    span{
        color: rgb(231, 61, 62);
    }
`

const Description = styled.div`

    h2{
        font-weight: 400;
    }

    @media(min-width: 768px){
        width: 50%;
    }
`

const Caption = styled.div``

const Methods = styled.div`
    display: flex;
    flex-direction: column;

`

const MdL = styled.div`
    display: flex;
    span{
        font-size: 24px;
        color: rgb(230, 61, 62);
        display: inline-block;
        width: 40px;
        height: 40px;
        border: 1px solid rgb(230, 61, 62);
        border-radius: 50%;
        padding: 5px 10px;
        margin-right: 20px;

    }
    div{
        h3{
            margin: 0;
        }
        @media(min-width: 768px){
            h3{
                font-size: 24px; 
            }
        }
    }
    

`

export default Funding